import { notification } from "antd";
import firebase from "firebase";
import React from "react";
import { auth, firestore } from "../firebase/config";
import { AuthContextType, EmailPasswordSignupData } from "../libs/Interfaces";
import { useApp } from "./AppContext";

auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);

const AuthContext = React.createContext<AuthContextType>({
    signUpEmail: (data: EmailPasswordSignupData) => Promise.resolve(console.log),
    loginWithEmail: (email: string, password: string, remember?: boolean) => Promise.resolve(console.log(email, password)),
    logout: () => console.log(),
    currentUser: null,
    signInWithGoogle: () => Promise.resolve(console.log("GOOGLE AUTH"))
});

export function useAuth() {
    return React.useContext(AuthContext);
}


export function AuthProvider({ children }: { children: any }) {

    const [currentUser, setCurrentUser] = React.useState<firebase.User | null>(null);
    const [loading, setLoading] = React.useState(true);
    const { loadingComponent } = useApp();

    async function signUpEmail(data: EmailPasswordSignupData) {
        auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);
        let signup = await auth.createUserWithEmailAndPassword(data.email, data.password);
        return saveUserData(signup.user?.uid, {
            info: {
                name: data.name,
                dob: data.dob,
                share: data.share
            }
        });
    }

    function saveUserData(uid: string | undefined, data: any) {
        if (!uid) return;
        console.log(uid,data);
        firestore.doc(`users/${uid}`).set(data);
    };

    async function signInWithGoogle() {
        let gProvider = new firebase.auth.GoogleAuthProvider();
        gProvider.addScope("profile");
        gProvider.addScope("email");
        try {
            let result = await auth.signInWithPopup(gProvider);;
            //alert(result);
            if (result.additionalUserInfo?.isNewUser) {
                
                saveUserData(result.user?.uid, {
                    credential: result.credential?.toJSON(),
                    info: {
                        profile: JSON.parse(JSON.stringify(result.additionalUserInfo.profile)),
                        providerId: result.additionalUserInfo.providerId,
                        username: result.additionalUserInfo.username ? result.additionalUserInfo.username : "empty"
                    }
                });
            }
        } catch (err) {
            //alert(err);
            notification.error({
                message: err.code,
                description: err.message,
            });
            console.error(err);
        }
    };

    /*async function signInWithFacebook() {
        let fProvider = new firebase.auth.FacebookAuthProvider;
        auth.signInWithRedirect(fProvider);
        try {
            let result = await auth.getRedirectResult();
            if (result.additionalUserInfo?.isNewUser) {
                let name = result.user?.displayName ? result.user.displayName : "User temp";
                saveUserData(result.user?.uid, name, {
                    day: 1,
                    month: 1,
                    year: 2020,
                }, true, {
                    type: result.credential?.providerId,
                    value: result.user?.providerData
                });
            }
        } catch (err) {
            notification.error({
                message: err.code,
                description: err.message,
            });
            console.error(err);
        }
    };*/

    function loginWithEmail(email: string, password: string, remember?: boolean) {
        console.log(remember);
        if (remember) auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);
        else auth.setPersistence(firebase.auth.Auth.Persistence.NONE);
        return auth.signInWithEmailAndPassword(email, password);
    }

    function logout() {
        return auth.signOut();
    }

    React.useEffect(() => {
        auth.setPersistence(firebase.auth.Auth.Persistence.SESSION);
        const unsubcscribe = auth.onAuthStateChanged(user => {
            setCurrentUser(user);
            setLoading(false);
        });
        //return removeEventListeners;
        return unsubcscribe;
    }, []);

    const value: AuthContextType = {
        currentUser: currentUser,
        logout: logout,
        signUpEmail: signUpEmail,
        loginWithEmail: loginWithEmail,
        signInWithGoogle
    };

    return (
        <AuthContext.Provider value={value}>
            {loading ? loadingComponent : children}
        </AuthContext.Provider>
    );
}